import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getLocalizedName } from '../../helpers';
import FileService from '../../apiclients/FileService';
import ContentService from '../../apiclients/ContentService';
import AppContext from '../../AppContext';
let cache = {};
const getResource = async (resourceType, resourceId) => {
    if (cache[`${resourceType}~${resourceId}`] !== undefined) {
        return cache[`${resourceType}~${resourceId}`];
    }
    let response;
    if (resourceType === 'content') {
        response = await ContentService.getContent(resourceId);

        response.resourceSubtype = response.objectType;
    } else {
        response = await FileService.getFiles([resourceId]);
        response = response[0];
        response.names = { default: response.filename };
        response.resourceSubtype = response.fileType;
    }
    cache[`${resourceType}~${resourceId}`] = response;
    return response;
};

export const getResourceName = async (resourceType, resourceId) => {
    let language = new AppContext().getLanguage();
    return getLocalizedName(language, (await getResource(resourceType, resourceId)).names);
};

class ResourceLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resource: undefined,
        };
    }

    componentDidMount() {
        this.refreshData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.resourceId !== this.props.resourceId) {
            this.refreshData();
        }
    }

    refreshData = async () => {
        try {
            this.setState({ resource: await getResource(this.props.resourceType, this.props.resourceId) });
        } catch (err) {
            console.log(err);
            //TODO: if 404 report boundTo has a non existing content
        }
    };

    goToResource = (evt) => {
        if (this.props.resourceType === 'content') {
            this.props.openContent(this.props.resourceId, this.state.resource.resourceSubtype, 'show', evt);
        } else if (this.props.resourceType === 'file') {
            this.props.openFileViewer(this.props.resourceId, this.state.resource.resourceSubtype);
        }
    };

    render() {
        let language = new AppContext().getLanguage();
        return (
            <div style={{ display: 'inline-block', cursor: 'pointer' }} onClick={this.goToResource}>
                {this.state.resource ? (
                    <div
                        dangerouslySetInnerHTML={{ __html: getLocalizedName(language, this.state.resource.names) }}
                        style={{ display: 'inline-block' }}
                    />
                ) : (
                    ''
                )}
            </div>
        );
    }
}
ResourceLink.propTypes = {
    resourceType: PropTypes.string.isRequired,
    resourceId: PropTypes.string.isRequired,
    openContent: PropTypes.func.isRequired,
    openFileViewer: PropTypes.func.isRequired,
};

export default ResourceLink;
